'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { getIsJitaUser } from '../../selectors/AccessSelector';
import { jsx as _jsx } from "react/jsx-runtime";
export default function JitaViewWarning() {
  const isJitaUser = useSelector(state => getIsJitaUser(state));
  if (!isJitaUser) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    use: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "jitaWarning.title"
    }),
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "jitaWarning.description"
    })
  });
}